<template>
<div class="register-box">
    <v-head :title="title"></v-head>
    <van-tabs color="#228ccd" type="card" style="margin-top:20px">
        <van-tab title="单位注册">
            <group></group>
        </van-tab>
        <van-tab title="个人注册">
            <person></person>
        </van-tab>
    </van-tabs>
</div>
</template>

<script>
import vHead from "../../../components/Subhead.vue";
import group from "./group";
import person from "./person";
import { Tab, Tabs} from "vant";
export default {
  data() {
    return {
      title:"账号注册"
    };
  },
  components: {
    vHead,
    group,
    person,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  methods: {

  }
};
</script>

<style lang="less" scoped>
/deep/.van-tabs__nav--card{margin:0 25px;}
/deep/.van-tabs__content{ padding:30px 30px 20px 30px}
</style>
